import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  timeZone: {
    description: 'Ship from dropdown time zone',
    defaultMessage: 'Time Zone',
    id: 'rh/pg5',
  },
  selectTimeZone: {
    description: 'Ship from dropdown select time zone',
    defaultMessage: 'Select time zone...',
    id: 'mA/85v',
  },
});
